import * as bi from 'react-bootstrap-icons';
import { Flex } from 'components';
import { Icon } from 'shared/components';
import './style.scss';

interface IProps {
  type: 'error' | 'warning' | 'success';
  children: React.ReactNode;
}

function MessagePoint(props: IProps) {
  return (
    <Flex gap={5}>
      <Icon
        color={props.type}
        className='point-icon-4dEb'
      >
        {props.type === 'success' && <bi.Check />}
        {props.type === 'error' && <bi.XCircle />}
        {props.type === 'warning' && <bi.ExclamationTriangle />}
      </Icon>
      <div>{props.children}</div>
    </Flex>
  );
}

export default MessagePoint;
